import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { formatTimestamp } from "../../lib";

const TEMPLATE: Record<string, (actor: string, school: string) => string> = {
  created: (actor, school) => `${actor} created ${school}`,
  updated: (actor, school) => `${actor} updated ${school}`,
  deleted: (actor, school) => `${actor} deleted ${school}`,
  admin_added: (actor, school) => `${actor} added an admin to ${school}`,
  admin_removed: (actor, school) => `${actor} removed an admin from ${school}`,
};

function describeActivity(row: {
  event_type: string | null;
  actor_name: string | null;
  school_name: string | null;
}): string {
  const actor = row.actor_name || "Someone";
  const school = row.school_name || "an unknown school";
  const template = row.event_type ? TEMPLATE[row.event_type] : null;
  if (!template) return `${actor} changed ${school}`;
  return template(actor, school);
}

// returns: array of latest 10 school_activity rows, each with
//   { ...row, school_name, actor_name, f_created_at, f_activity }
export const recent_school_activity: Query<Ctx> = async ({ sb }, _params) => {
  const { data } = await sb
    .from("v_recent_school_activity")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(10);
  if (!data) return [];

  return data.map((row: any) => ({
    ...row,
    f_created_at: formatTimestamp(row.created_at),
    f_activity: describeActivity(row),
  }));
};
